import React from 'react';

import {
    Grid,
    Card,
    CardContent,
    Typography,
    makeStyles
} from '@material-ui/core'

import ListagemContato from '../containers/ListagemContato';

const useStyles = makeStyles(theme => ({
    titulo: {
        color: theme.palette.primary.main
    },
    subtitulo: {
        color: theme.palette.text.primary,
        marginTop: theme.spacing(2)
    },
    texto: {
        color: theme.palette.text.secondary,
        marginTop: theme.spacing(1)
    }
}));

function CardErro() {
    const classes = useStyles();

    return (
        <Grid container
            justify='center'
            alignItems='center'>
            <Grid item>
                <Typography variant='h2'
                    className={classes.titulo}>
                    Ops! <span aria-hidden="true" role="img">😕</span>
                </Typography>
                <Typography variant='h5'
                    className={classes.subtitulo}>
                    Algo deu errado. Por favor, tente novamente daqui alguns minutos.
                    </Typography>
                <Typography variant='body2'
                    className={classes.texto}>
                    Se o problema persistir, entre em contato com a gente:
                    </Typography>
                <ListagemContato />
            </Grid>
        </Grid>
    );
}

export default CardErro;